import { render, staticRenderFns } from "./KonekoADashboardWorkload.vue?vue&type=template&id=6ba579c0&scoped=true"
import script from "./KonekoADashboardWorkload.vue?vue&type=script&lang=js"
export * from "./KonekoADashboardWorkload.vue?vue&type=script&lang=js"
import style0 from "./KonekoADashboardWorkload.vue?vue&type=style&index=0&id=6ba579c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba579c0",
  null
  
)

export default component.exports